import React, {useEffect, useRef} from 'react';
import './copyright.scss';

import { userSetVisibleSubFooterAC } from '@entities/user/model/user.actions';
import { Link } from 'react-router-dom';
import { Text, Icon } from '@ui-kit';
import { useOnScreen } from '@shared';
//const Instagram = '/images/icons/social/instagram-gray400.svg';
const Dribbble = '/images/icons/social/dribbble-gray400.svg';
const Behance = '/images/icons/social/behance-gray400.svg';
import { useDispatch } from 'react-redux';


const Copyright = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const isVisibleSubFooter = useOnScreen(ref);

    const currentYear = new Date().getFullYear();
    
    useEffect(() => {
        dispatch(userSetVisibleSubFooterAC(isVisibleSubFooter));
    // eslint-disable-next-line
    },[isVisibleSubFooter])

    return (
        <div className="sub-footer__container d-flex" ref={ref}>
            <Icon src="/images/main_logo-w.png" className="sub-footer__logo"/>
            <div className="sub-footer__content d-flex">
                <Text as="span" className="sub-footer__text">
                    {`© 2021-${currentYear} FlowPik | All Rights Reserved`}
                </Text>
                <div className="sub-footer__social d-flex">
                    {/*<Link to={"https://instagram.com/"} target="_blank" rel="noreferrer">
                        <Icon src={Instagram} alt="instagram icon"/>
                    </Link>*/}
                    <Link to={"https://www.behance.net/briefstock"} target="_blank" rel="noreferrer">
                        <Icon src={Behance} alt="behance icon"/>
                    </Link>
                    <Link to={"https://dribbble.com/myteamart"} target="_blank" rel="noreferrer">
                        <Icon src={Dribbble} alt="dribbble icon"/>
                    </Link>
                    {/*<Link to={"https://pinterest.com/"} target="_blank" rel="noreferrer">
                        <Icon src={Instagram} alt="pinterest icon"/>
                    </Link>*/}
                </div>
            </div>
        </div>
    )
};

export default Copyright;
